import { render, staticRenderFns } from "./MaterialsSuppliersSearchDropdown.vue?vue&type=template&id=a4e57810&"
import script from "./MaterialsSuppliersSearchDropdown.vue?vue&type=script&lang=js&"
export * from "./MaterialsSuppliersSearchDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports